import template from './cookies.html'
import controller from './cookies.controller'

let component = {
  restrict: 'E',
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/cookies/cookies.component.js